import type { ApiResponse, BaseFilterParams, Paginated } from "../types/api";
import type {
  CreateRfidTagPayload,
  RfidTag,
  UpdateRfidTagPayload,
} from "../types/rfidTag";
import api from "./client";

interface RfidTagFilterParams extends BaseFilterParams {
  status?: string;
}

export const rfidTagApi = {
  create: (body: CreateRfidTagPayload): Promise<ApiResponse<RfidTag>> =>
    api.post("/rfid-tag", body),

  getAll: (
    params?: RfidTagFilterParams
  ): Promise<ApiResponse<Paginated<RfidTag[]>>> =>
    api.get("/rfid-tag", { params }),

  getById: (id: number): Promise<ApiResponse<RfidTag>> =>
    api.get(`/rfid-tag/${id}`),

  update: (
    id: number,
    body: Partial<UpdateRfidTagPayload>
  ): Promise<ApiResponse<RfidTag>> => api.patch(`/rfid-tag/${id}`, body),

  delete: (id: number): Promise<ApiResponse<void>> =>
    api.delete(`/rfid-tag/${id}`),

  bulkDelete: (ids: number[]): Promise<ApiResponse<{ deleted: number; requested: number }>> =>
    api.delete("/rfid-tag/bulk", { data: { ids } }),
};
